import { useState, useContext, useEffect } from "react";
import { CanvasContext } from "../App";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import { RiMenu2Fill } from "react-icons/ri";
import Menu from "./Menu";
import styled from "styled-components";

const CustomOffcanvas = styled(Offcanvas)`
  background-color: #343a40;
  color: white !important;
  font-weight: 300 !important;
`;

function MenuOffcanvas({ isOpen, changeData }) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const canvas = useContext(CanvasContext);

  useEffect(() => {
    canvas && setShow(false);
  }, [canvas, isOpen]);

  //console.log("Canvas isOpen: ", isOpen);

  return (
    <>
      <Button
        variant="outline-light"
        onClick={handleShow}
        style={{
          backgroundColor: "#2c3e50",
          width: "120px",
          marginLeft: "10%",
        }}
      >
        <RiMenu2Fill />
      </Button>
      <CanvasContext.Provider value={show}>
        <CustomOffcanvas show={show} onHide={handleClose} className="offcanvas">
          <Offcanvas.Header closeButton>
            <Offcanvas.Title
              style={{
                width: "100%",
                textAlign: "center",
              }}
            >
              Michał Jaskulski
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Menu isOpen="true" changeData={changeData} />
          </Offcanvas.Body>
        </CustomOffcanvas>
      </CanvasContext.Provider>
    </>
  );
}

export default MenuOffcanvas;
